import React, {useEffect, useRef} from 'react';
import {ReactComponent as SearchIcon} from "../../../../../../asset/icons/searchIcon.svg";
import {useTranslation} from "react-i18next";

function DetailStatusSearch({onClick, value}) {
  const {t} = useTranslation()
  const inputRef = useRef(null)

  useEffect(() => {
    inputRef.current.value = value
  }, [value])

  return (
    <div className='detail-status-search'>
      <button
        className="detail-status-filter-box detail-status-search-btn"
        onClick={() => onClick(inputRef.current.value)}>
        <SearchIcon/>
      </button>
      <input
        ref={inputRef}
        className='detail-status-input-search'
        type="text"
        placeholder={t('Src.Pages.CustomerClub.Components.OfferManagment.DetailStatus.search.placeholder')}
      />
    </div>
  );
}

export default DetailStatusSearch;
